import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";
import { getUserData } from "../utils/authnicate";

/**
 * Uploads a zip/folder of onboarding documents.
 * POST api/BulkUpload/upload-onboarding-documents
 * multipart/form-data: file (zip) + createdBy
 *
 * @param {File} file - ZIP file
 * @param {(pct: number) => void} [onProgress] - optional progress callback (0-100)
 */
export const uploadOnboardingDocumentsAction = async (file, onProgress) => {
  try {
    const loggedInUser = getUserData();
    const createdBy =
      loggedInUser?.email ||
      loggedInUser?.name ||
      loggedInUser?.username ||
      "Admin";

    const formData = new FormData();
    formData.append("file", file);
    formData.append("createdBy", createdBy);

    const response = await apiClient.post(
      ATP_API_URL.UPLOAD_ONBOARDING_DOCUMENTS,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (e) => {
          if (onProgress && e.total) {
            onProgress(Math.round((e.loaded * 100) / e.total));
          }
        },
      },
    );

    if (response?.status === 200 && response.data) {
      const { success, message } = response.data;
      return {
        success: !!success,
        message:
          message ||
          (success ? "Documents uploaded successfully" : "Upload failed"),
      };
    }
    return { success: false, message: "Upload failed" };
  } catch (error) {
    console.error("[UploadOnboardingDocuments] error:", error);
    return {
      success: false,
      message:
        error.response?.data?.message || error.message || "Upload failed",
    };
  }
};
